import React, { useEffect, useState, useRef } from 'react';
interface FadeInViewProps {
  children: React.ReactNode;
  className?: string;
}
export function FadeInView({
  children,
  className = ''
}: FadeInViewProps) {
  const ref = useRef<HTMLDivElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '-80px',
      threshold: 0
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} className={`${className} transition-all duration-700 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-5'}`} data-id="element-403">
      {children}
    </div>;
}